// extracted by mini-css-extract-plugin
export var closeMenu = "styles-module--close-menu--onefs";
export var isLast = "styles-module--is-last--sWv9A";
export var lanHolder = "styles-module--lan-holder--ZAMH-";
export var lanLink = "styles-module--lan-link--dQBT7";
export var menuOpen = "styles-module--menu-open--ht9MN";
export var mobileNavElectronic = "styles-module--mobile-nav-electronic--rYAnU";